export default "<div id=\"content\">\r\n  Profile will go here...\r\n</div>\r\n"